module.exports = __webpack_public_path__ + "img/stage_drachenkopf2.6aab5ec2.jpg";